import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import { userAPi } from '../api/api'
import { AuthUser, SignInForm, SignUpForm, UpdateUserForm } from '../types/user'
import { decodeData } from '../utils/encrypt/decodeData'
// import {
//   CalendarUser,
//   CreateUser,
//   User,
//   UpcomingUsers,
// } from '../types/user'
// import { loadUsers, modifyUser, removeUser, saveUser } from '../api/user'
// import { findCurrentTimePeriodUsers } from '../utils/findCurrentTimePeriodUsers'
// import { isWithinInterval } from 'date-fns'
// import { findUsersByDate } from '../utils/findUsersByDate'

//signUp user
export const signUp = createAsyncThunk(
  'user/signUp',
  async (signupForm: SignUpForm, thunkApi) => {
    try {
      return await userAPi.signUpUser(signupForm)
    } catch (e) {
      return thunkApi.rejectWithValue('getUsersError')
    }
  },
)

// login user
export const login = createAsyncThunk(
  'user/login',
  async (loginForm: SignInForm, thunkApi) => {
    try {
      return await userAPi.signInUser(loginForm)
    } catch (e) {
      return thunkApi.rejectWithValue('getUsersError')
    }
  },
)

// verify user
export const verifyUser = createAsyncThunk(
  'user/verify',
  async (_, thunkApi) => {
    try {
      return await userAPi.verifyUser()
    } catch (e) {
      return thunkApi.rejectWithValue('getUsersError')
    }
  },
)

// update user
export const updateUser = createAsyncThunk(
  'user/updateUser',
  async (user: UpdateUserForm, thunkApi) => {
    try {
      return await userAPi.updateUser(user)
    } catch (e) {
      return thunkApi.rejectWithValue('updateUserError')
    }
  },
)

// log out
export const logout = createAsyncThunk('user/logout', async (_, thunkApi) => {
  try {
    return await userAPi.logout()
  } catch (e) {
    return thunkApi.rejectWithValue('logoutError')
  }
})

interface UserSliceState {
  authUser?: AuthUser
  isUserVerified: boolean
  loading: boolean
  error?: SerializedError
}

const initialState: UserSliceState = {
  authUser: undefined,
  isUserVerified: false,
  loading: false,
  error: undefined,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // setCalendarUsers: (
    //   state: UserSliceState,
    //   action: PayloadAction<CalendarUser[]>,
    // ) => {
    //   state.calendarUsers = action.payload
    // },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    // signUp user
    // @ts-ignore
    builder.addCase(
      signUp.fulfilled,
      (state: UserSliceState, action: PayloadAction<string>) => {
        const decodedUser = decodeData(action.payload) as AuthUser
        state.authUser = decodedUser
        if (action.payload) {
          state.isUserVerified = true
        }
        state.error = undefined
      },
    )

    builder.addCase(signUp.pending, (state: UserSliceState, action) => {
      state.error = undefined
    })

    builder.addCase(signUp.rejected, (state, action) => {
      state.error = action.payload
    })

    // login user
    // @ts-ignore
    builder.addCase(
      login.fulfilled,
      (state: UserSliceState, action: PayloadAction<string>) => {
        const decodedUser = decodeData(action.payload) as AuthUser
        state.authUser = decodedUser
        if (action.payload) {
          state.isUserVerified = true
        }
        state.error = undefined
      },
    )

    builder.addCase(login.pending, (state: UserSliceState, action) => {
      state.error = undefined
    })

    builder.addCase(login.rejected, (state, action) => {
      state.error = action.payload
    })

    // login verify
    // @ts-ignore
    builder.addCase(
      verifyUser.fulfilled,
      (state: UserSliceState, action: PayloadAction<string>) => {
        const decodedUser = decodeData(action.payload) as AuthUser
        state.authUser = decodedUser
        if (action.payload) {
          state.isUserVerified = true
        }
        state.error = undefined
      },
    )
    builder.addCase(verifyUser.pending, (state: UserSliceState, action) => {
      state.error = undefined
    })
    builder.addCase(verifyUser.rejected, (state, action) => {
      state.error = action.payload
    })

    // login update user
    // @ts-ignore
    builder.addCase(
      updateUser.fulfilled,
      (state: UserSliceState, action: PayloadAction<string>) => {
        const decodedUser = decodeData(action.payload) as AuthUser
        state.authUser = decodedUser
        if (action.payload) {
          state.isUserVerified = true
        }
        state.error = undefined
      },
    )
    builder.addCase(updateUser.pending, (state: UserSliceState, action) => {
      state.error = undefined
    })
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload
    })

    // logout logout
    // @ts-ignore
    builder.addCase(
      logout.fulfilled,
      (state: UserSliceState, action: PayloadAction<string>) => {
        state.authUser = undefined
        if (action.payload) {
          state.isUserVerified = true
        }
        state.error = undefined
      },
    )
    builder.addCase(logout.pending, (state: UserSliceState, action) => {
      state.error = undefined
    })
    builder.addCase(logout.rejected, (state, action) => {
      state.error = action.payload
    })
  },
})

export const {} = userSlice.actions
export default userSlice
